/* The chooser on the floor and table collection pages (21 Sep 2026, Josh's brief).

   Three questions decide the light: the beam, power, and how the brightness is
   controlled. A fourth, optional, only shapes the set-up note on the result. A fifth,
   on every quiz since 24 Sep 2026 (Josh: always five), asks floor or table and picks
   that format's product (model(id, format)). The
   dialog's markup and every visible word of the questions live in
   sections/v4-collection-cat-chooser.liquid; this script moves between the steps,
   keeps the answers in memory (nothing is sent anywhere), and writes the result.

   The picking rule, in order:
     battery or remote wanted                                  -> HD Pro
     beam to be shaped or concentrated, or a thumbwheel wanted -> HD Original
     unsure about the beam or the control                      -> compare Essential and Original
     otherwise                                                 -> HD Essential

   The result shows: best fit, why it fits you, what you get, what to know, why not the
   other two, the set-up note, the trial and warranty line, the button, the phone.
   Model names, prices, pictures and links come from the range section's data. */
(function () {
  var arrow = '<span class="arrow" aria-hidden="true">&#8594;</span>';
  var PHONE = '0800 032 9366';

  var rangeModels = (function () {
    try {
      return Array.prototype.map.call(document.querySelectorAll('script[data-range-model]'), function (el) { return JSON.parse(el.textContent); });
    } catch (e) { return []; }
  })();
  /* Each light can be published twice, floor and table (24 Sep 2026: every quiz asks where the light will stand), so
     the answer picks the right product; a page that publishes one format still finds its light. */
  function model(id, format) {
    var hit = format ? rangeModels.find(function (m) { return m.id === id && m.format === format; }) : null;
    return hit || rangeModels.find(function (m) { return m.id === id; }) || missing(id, format);
  }
  /* A light the page does not publish at all (unpublished, say) used to give a Choose button that went nowhere ('#').
     It now names the light and sends the visitor to the floor or table lights instead (coverage audit, 25 Sep 2026). */
  function missing(id, format) {
    var names = { essential: 'HD Essential', original: 'HD Original', pro: 'HD Pro' };
    return { id: id, name: names[id] || 'right light', url: format === 'table' ? '/collections/table-lights' : '/collections/floor-lights', price: '', image: '', missing: true };
  }
  function escapeAttr(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function picture(m, format) {
    if (!m.image) return '';
    return '<img src="' + escapeAttr(m.image) + '" alt="' + escapeAttr(m.name + ' ' + format + ' light') + '" width="1500" height="1500" loading="lazy" decoding="async">';
  }
  // The price is an offer slot (snippets/v4-offer-display.liquid): a code holder sees the offer figure, and the "From"
  // word shows or hides with it. m.handle comes from the range data.
  function price(m) { return '<span data-sr-from' + (m.id === 'pro' ? '' : ' hidden') + '>From </span><strong data-sr-fig>' + m.price + '</strong>'; }

  /* Use opens the chooser (Josh, 21 Sep): it only shapes the set-up note and can be skipped. */
  var questions = (function () {
    // Read the questions off the page, so a template can ask one more (the model category
    // pages ask floor or table). A page whose steps carry no id keeps the original four.
    var steps = document.querySelectorAll('[data-quiz-step][data-quiz-id]');
    if (!steps.length) {
      return [
        { id: 'activity', short: 'Use', optional: true },
        { id: 'beam', short: 'Beam' },
        { id: 'power', short: 'Power' },
        { id: 'control', short: 'Controls' }
      ];
    }
    return Array.prototype.map.call(steps, function (el) {
      return {
        id: el.dataset.quizId,
        short: el.dataset.quizShort || el.dataset.quizId,
        optional: el.hasAttribute('data-quiz-optional')
      };
    });
  })();
  var required = questions.filter(function (q) { return !q.optional; });
  var state = { step: 0, answers: {}, opener: null, sent: false };
  // 27 Oct 2026: the chooser tells Analytics when it is opened and which light it chose, the same way the add-ons
  // panel does (assets/v4-upsell.js), so the test can show whether it helps people buy. Never in the chooser's way.
  function track(name, params) {
    params = params || {};
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) { /* never in the way */ }
    try {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') analytics.publish(name, params);
    } catch (e) { /* never in the way */ }
  }

  // 28 Oct 2026 (Josh: "focusing on what they want... not things they don't know"): the questions are about the person, and the
  // light is worked out from the answers. beam = how small print is (wide = fine, adjust = more effort, focus = a struggle);
  // power = where (mains = one place, move = a few rooms, battery = anywhere); control = remote (yes) or simple (no).
  function recommendation(a) {
    var effort = a.beam === 'adjust' || a.beam === 'focus' || a.beam === 'unsure';
    var detail = a.activity === 'sewing' || a.activity === 'making';
    if (a.control === 'remote' || a.power === 'move' || a.power === 'battery') return ['pro'];
    if (effort || detail) return ['original'];
    if (a.activity === 'mix') return ['essential', 'original'];
    return ['essential'];
  }

  /* What each light gives you, as the customer would list it. Only verified facts. */
  function getList(id, format, short) {
    var floor = format === 'floor';
    var lists = {
      // Bases (Josh, 22 Sep): the HD Essential and the HD Original come with the Heavyweight or the
      // Lightweight base; the HD Pro has one base.
      essential: ['Daylight Wavelength Technology™', '8x more light on your page than a 60W bulb', 'One button sets the brightness, and it remembers your setting', 'A beam sized for an open book', 'Heavyweight or Lightweight base', 'Five-year warranty', '30-day home trial'],
      original: ['Daylight Wavelength Technology™', 'Up to 12x more light on your page than a 60W bulb', 'Narrow the beam for fine detail, or widen it for a newspaper', 'A wheel on the light sets the brightness, and it remembers your setting', 'Heavyweight or Lightweight base', 'Five-year warranty', '90-day home trial'],
      pro: ['Daylight Wavelength Technology™', 'Up to 12x more light on your page than a 60W bulb', 'Narrow the beam for fine detail, or widen it for a newspaper', 'Add a remote to change the brightness from across the room', 'Add a battery to use it away from a plug', 'Five-year warranty', '90-day home trial']
    };
    var list = lists[id];
    if (short) list = list.filter(function (line) { return !/Daylight|Five-year|value/.test(line); });
    return '<ul class="cat-quiz-get">' + list.map(function (line) { return '<li>' + line + '</li>'; }).join('') + '</ul>';
  }

  function toKnow(id, format) {
    if (id === 'essential') return 'Its beam stays the same width, and it plugs into the mains.';
    if (id === 'original') return 'It plugs into the mains, and it does not take a remote or a battery.';
    return 'The price shown is for the mains light. The battery and the remote cost extra.';
  }

  function whyItFits(id, a) {
    var loves = { reading: 'You love reading', sewing: 'You love sewing', making: 'You love your jigsaws, painting and crafts', mix: 'You love reading and your hobbies' };
    var thing = (a.activity === 'sewing' || a.activity === 'making') ? 'fine detail' : 'small print';
    var eyes = { wide: 'you would like a better light for it', adjust: thing + ' takes more effort than it used to', focus: thing + ' is a struggle, even with good light', unsure: '' };
    var alone = { wide: 'You would like a better light.', adjust: 'Small print takes more effort than it used to.', focus: 'Small print is a struggle, even with good light.', unsure: '' };
    var love = loves[a.activity], eye = eyes[a.beam];
    var lead = love && eye ? love + ', and ' + eye + '. ' : love ? love + '. ' : (alone[a.beam] ? alone[a.beam] + ' ' : '');
    if (id === 'pro') {
      var moving = a.power === 'move' || a.power === 'battery';
      var line = a.control === 'remote' && moving
        ? 'The HD Pro takes a remote, so you can turn it brighter or off from across the room, and a battery, so you can use it away from a plug.'
        : a.control === 'remote'
          ? 'The HD Pro takes a remote, so you can turn it brighter or off from across the room.'
          : 'The HD Pro takes a battery that lasts about 6.5 hours a charge, so you can carry it from room to room.';
      line += ' It gives you the same light as the HD Original.';
      /* Outside the UK the HD ROAM is not sold, so the dialog carries data-quiz-uk-only (snippets/sr-uk-only.liquid)
         and only the HD Mini is named (28 Oct 2026). */
      var quizEl = document.getElementById('category-quiz');
      var ukOnly = ',' + ((quizEl && quizEl.getAttribute('data-quiz-uk-only')) || '') + ',';
      if (a.power === 'battery') {
        if (ukOnly.indexOf(',roam-light,') > -1) line += ' If you want something smaller to take away with you, the <a href="/products/compact-cordless-light">HD Mini</a> runs on its own battery, with less light on your page than the HD Pro.';
        else line += ' If you want something smaller to take away with you, the <a href="/products/compact-cordless-light">HD Mini</a> and the <a href="/products/roam-light">HD ROAM</a> run on their own batteries, with less light on your page than the HD Pro.';
      }
      return lead + line;
    }
    if (id === 'original') {
      return lead + ((a.activity === 'sewing' || a.activity === 'making')
        ? 'The HD Original puts up to 12x more light on your page than a 60W bulb, and you can narrow the beam to put the most light on your work.'
        : 'The HD Original puts up to 12x more light on your page than a 60W bulb, and you can narrow the beam for small print or widen it for a newspaper.');
    }
    return lead + 'The HD Essential puts 8x more light on your page than a 60W bulb, and one button sets the brightness.';
  }

  function whyNotOthers(ids, a) {
    var lines;
    if (ids.length > 1) lines = [['HD Pro', 'it takes a battery and a remote, which you did not ask for.']];
    else if (ids[0] === 'original') lines = [['HD Essential', 'less light on your page, and its beam stays the same width.'], ['HD Pro', 'the same light, and it also takes a battery and a remote, which you did not ask for.']];
    else if (ids[0] === 'essential') lines = [['HD Original', 'more light on your page, and a beam you can narrow for fine detail.'], ['HD Pro', 'the same light as the HD Original, and it also takes a battery and a remote.']];
    else lines = [['HD Original', 'the same light, but it stays plugged in and has no remote.'], ['HD Essential', 'less light on your page, and it stays plugged in with no remote.']];
    return '<div class="cat-quiz-others"><h4>' + (ids.length > 1 ? 'Why not the HD Pro?' : 'Why not the other two?') + '</h4>' +
      lines.map(function (l) { return '<p><strong>' + l[0] + ':</strong> ' + l[1] + '</p>'; }).join('') + '</div>';
  }

  function setupNote(a) {
    var notes = {
      reading: 'Stand the light beside or just behind where you read, and bring the head over your shoulder, so the light falls on your book and not in your eyes.',
      sewing: 'Bring the head in close over your work and angle it so your hands do not cast a shadow across the stitches.',
      making: 'Set the head above and a little in front of your work, so the colours are lit evenly and your hand does not shadow the detail.',
      mix: 'Put the base where you can swing the head between your book and your work without moving the light.'
    };
    var note = notes[a.activity];
    if (!note) return '';
    if (a.power === 'move') note += ' If you will move it often, compare the base weights on the product page.';
    return '<div class="cat-quiz-setup"><h4>When you set it up</h4><p>' + note + '</p></div>';
  }

  function trialLine(id) {
    return '<p class="cat-quiz-trial">' + (id === 'essential' ? '30 days' : '90 days') + ' at home and a five-year warranty. If it is not right for you, we collect it from a UK mainland address.</p>';
  }

  function buyRow(m, verb) {
    if (m.missing) return '<div class="cat-quiz-buy"><a class="btn gold" href="' + escapeAttr(m.url) + '">See the ' + (/table/.test(m.url) ? 'table' : 'floor') + ' lights ' + arrow + '</a></div>';
    return '<div class="cat-quiz-buy"><p class="cat-price" data-category-price="' + m.id + '" data-sr-price="from" data-handle="' + escapeAttr(m.handle || '') + '" data-sr-p="lux">' + price(m) + ' <s class="sro-was" data-sr-was hidden></s><span class="sro-note" data-sr-note hidden></span></p><a class="btn gold" href="' + escapeAttr(m.url) + '" aria-label="' + verb + ' the ' + escapeAttr(m.name) + '">' + verb + ' the ' + m.name + ' ' + arrow + '</a></div>';
  }

  function result(format, a) {
    var ids = recommendation(a);
    if (ids.length > 1) {
      return '<h3 id="cat-quiz-result-title" tabindex="-1">The HD Essential or the HD Original</h3>' +
        '<p class="cat-quiz-result-intro">Both would suit you. The HD Original gives you more light on your page and a beam you can narrow for your hobbies, and the HD Essential is the simpler of the two.</p>' +
        '<div class="cat-quiz-recommendations cat-two-recommendations">' + ids.map(function (id) {
          var m = model(id, format);
          var why = id === 'essential' ? 'One button sets the brightness, and its beam is sized for an open book.'
            : 'More light on your page, and a beam you can narrow for fine work or widen for a newspaper.';
          return '<article>' + picture(m, format) + '<div><h4>' + m.name + '</h4><h5>Why you might choose it</h5><p>' + why + '</p><h5>What you get</h5>' + getList(id, format, true) + '<h5>What to know</h5><p class="cat-quiz-tradeoff">' + toKnow(id, format) + '</p>' + buyRow(m, 'Choose') + '</div></article>';
        }).join('') + '</div>' +
        whyNotOthers(ids, a) + setupNote(a) +
        '<p class="cat-quiz-advice">You can change any answer above, or talk it through on <a href="tel:' + PHONE.replace(/ /g, '') + '">' + PHONE + '</a>.</p>';
    }
    var id = ids[0], m = model(id, format);
    return '<h3 id="cat-quiz-result-title" tabindex="-1">Best fit: ' + m.name + '</h3>' +
      '<div class="cat-quiz-recommendations"><article>' + picture(m, format) +
        // The price and the button sit right under the reason (Josh, 22 Sep), and again at the end.
        '<div><h5>Why it fits you</h5><p>' + whyItFits(id, a) + '</p>' + buyRow(m, 'Choose') +
        '<h5>What you get</h5>' + getList(id, format, false) +
        '<h5>What to know</h5><p class="cat-quiz-tradeoff">' + toKnow(id, format) + '</p></div>' +
      '</article></div>' +
      whyNotOthers(ids, a) + setupNote(a) + trialLine(id) + buyRow(m, 'Choose') +
      '<p class="cat-quiz-advice">You can change any answer above, or talk it through on <a href="tel:' + PHONE.replace(/ /g, '') + '">' + PHONE + '</a>.</p>';
  }

  function allRequired() { return required.every(function (q) { return state.answers[q.id]; }); }

  function render(focus) {
    var dialog = document.getElementById('category-quiz');
    if (!dialog) return;
    var step = state.step, answers = state.answers, finished = step === questions.length;
    var stage = dialog.querySelector('.cat-quiz-stage'), out = dialog.querySelector('.cat-quiz-result');
    stage.hidden = finished; out.hidden = !finished;
    // Where the light will stand: the visitor's own answer when the page asked for it.
    if (finished) out.innerHTML = result(answers.format || dialog.dataset.quizFormat || 'floor', answers);
    if (finished && window.SROffer) window.SROffer.paint(out);
    if (finished && !state.sent) { state.sent = true; track('chooser_finish', { light: recommendation(answers).join('+') }); }
    dialog.querySelectorAll('[data-quiz-step]').forEach(function (section, index) {
      var active = !finished && index === step;
      // The attribute, not the property: Safari before 15.5 has no inert property, so setting it left questions 2 to 5
      // hidden under the attribute the page is drawn with and the quiz stopped at question 1 (feedback check, 3 Nov 2026).
      section.toggleAttribute('inert', !active); section.setAttribute('aria-hidden', String(!active));
      section.querySelector('fieldset').disabled = !active;
    });
    dialog.querySelectorAll('[data-quiz-answer]').forEach(function (input) { input.checked = answers[input.dataset.quizAnswer] === input.value; });
    dialog.querySelectorAll('[data-quiz-goto]').forEach(function (button, index) {
      var q = questions[index];
      button.disabled = index !== step && !answers[q.id] && !(q.optional && allRequired());
      button.toggleAttribute('data-complete', Boolean(answers[q.id]));
      if (index === step) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
    });
    dialog.querySelector('[data-quiz-status]').textContent = finished ? 'Your recommendation is ready' : 'Question ' + (step + 1) + ' of ' + questions.length;
    var next = dialog.querySelector('[data-quiz-next]'), back = dialog.querySelector('[data-quiz-back]'), skip = dialog.querySelector('[data-quiz-skip]');
    var current = questions[step];
    next.hidden = finished; back.hidden = finished; back.disabled = step === 0;
    next.disabled = !finished && !answers[current.id];
    next.innerHTML = (step === questions.length - 1 ? 'See recommendation' : 'Continue') + ' ' + arrow;
    if (skip) skip.hidden = finished || !(current && current.optional) || Boolean(answers[current.id]);
    dialog.querySelector('[data-quiz-restart]').hidden = !finished;
    dialog.querySelector('[data-quiz-finish]').hidden = !finished;
    if (focus) {
      var target = finished ? out.querySelector('h3') : dialog.querySelector('#cat-question-' + current.id);
      // Straight to the top: scrollTop works in every browser, where a scrollTo 'instant' may not on older Safari.
      var scroller = dialog.querySelector('.cat-guide-scroll'); if (scroller) scroller.scrollTop = 0;
      if (target) target.focus({ preventScroll: true });
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        (finished ? out : dialog.querySelector('[data-quiz-step="' + step + '"]')).animate([{ opacity: .35, transform: 'translateY(4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 180, easing: 'ease-out' });
      }
    }
  }

  function close() {
    var dialog = document.getElementById('category-quiz');
    if (!dialog || !(dialog.open || dialog.hasAttribute('open'))) return;
    if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
    if (state.opener) state.opener.focus({ preventScroll: true });
  }

  document.addEventListener('cancel', function (event) {
    if (event.target.id !== 'category-quiz') return;
    event.preventDefault(); close();
  }, true);
  document.addEventListener('keydown', function (event) {
    var dialog = document.getElementById('category-quiz');
    if (event.key !== 'Tab' || !dialog || !(dialog.open || dialog.hasAttribute('open'))) return;
    var stops = Array.prototype.filter.call(dialog.querySelectorAll('a[href],button,input,summary,[tabindex="0"]'), function (el) { return !el.disabled && el.tabIndex >= 0 && !el.closest('[inert],[hidden]') && el.getClientRects().length; });
    var first = stops[0], last = stops[stops.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('change', function (event) {
    var key = event.target.dataset.quizAnswer;
    if (!key) return;
    state.answers[key] = event.target.value;
    var dialog = document.getElementById('category-quiz');
    dialog.querySelector('[data-quiz-next]').disabled = false;
    var skip = dialog.querySelector('[data-quiz-skip]');
    if (skip) skip.hidden = true;
  });
  document.addEventListener('click', function (event) {
    var start = event.target.closest('[data-start-chooser]');
    if (start) {
      var dialog = document.getElementById('category-quiz');
      // A browser without <dialog> (Safari before 15.4): a link keeps its own jump to the chooser on the page (launch audit,
      // 25 Sep 2026); a button, which has nowhere to jump, opens the panel with the open attribute instead, which the
      // closed-panel rule in layout/theme.liquid then stops hiding (full audit round 3, 8 Oct 2026).
      if (!dialog || (typeof dialog.showModal !== 'function' && start.tagName === 'A' && start.getAttribute('href'))) return;
      event.preventDefault();
      state.opener = start;
      track('chooser_open', {});
      render(); if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', ''); render(true); return;
    }
    if (!event.target.closest('#category-quiz')) return;
    if (event.target.closest('[data-quiz-close]')) { close(); return; }
    var goto = event.target.closest('[data-quiz-goto]');
    if (goto && !goto.disabled) state.step = Number(goto.dataset.quizGoto);
    else if (event.target.closest('[data-quiz-next]')) {
      var current = questions[state.step];
      if (!current || !state.answers[current.id]) return;
      state.step = state.step + 1;
    } else if (event.target.closest('[data-quiz-skip]')) {
      var skipping = questions[state.step];
      if (!skipping || !skipping.optional) return;
      state.step = state.step + 1;
    } else if (event.target.closest('[data-quiz-back]')) state.step = Math.max(0, state.step - 1);
    else if (event.target.closest('[data-quiz-restart]')) { state.step = 0; state.answers = {}; state.sent = false; }
    else return;
    render(true);
  });
})();
